document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('.hueTarget');
  if (!elements.length) return;

  const DURATION = 15000; // 15 seconds

  // Add smooth transition for initial blend
  elements.forEach(el => {
    el.style.transition = 'filter 0.5s linear';
  });

  let start = null;

  function animateHue(timestamp) {
    if (!start) start = timestamp; // set baseline once
    const elapsed = (timestamp - start) % DURATION;
    const angle = (elapsed / DURATION) * 360;

    elements.forEach(el => {
      el.style.filter = `hue-rotate(${angle}deg)`;
    });

    requestAnimationFrame(animateHue);
  }

  // Add a short delay so the first frame doesn’t “jump”
  setTimeout(() => requestAnimationFrame(animateHue), 300);
});
